import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlFormat',
})
export class HtmlFormatPipe implements PipeTransform {
  transform(content: string): string {
    return this.formattedHTML(content) || '';
  }

  formattedHTML(content: string): string {
    const newContent = content.replace(
      /<br><br>/g,
      '<div class="divider"></div>'
    );
    return newContent;
  }
}
